import { ProjectRoleNameEditor } from "@/containers/Admin/ProjectRoles";
import { CONTENT_WIDTH, GUTTER_SIZE } from "@/enums";
import { IProjectRole } from "@/interfaces";
import { Col, Row } from "antd";

interface IProps {
  role: IProjectRole;
  handleUnsavedChanges(hasUnsavedChanges: boolean): void;
}

export const NewProjectRole = ({ role, handleUnsavedChanges }: IProps) => (
  <>
    <Row gutter={GUTTER_SIZE.large}>
      <Col span={CONTENT_WIDTH.half}>
        <ProjectRoleNameEditor
          role={role}
          originalRole={role}
          handleUnsavedChanges={handleUnsavedChanges}
        />
      </Col>
    </Row>
  </>
);
